import {api} from './requestGraphql'

const verticalGroup = async (payload) => {

  try {
    const res = await api.post(
      '', {
        query: `
            {
              verticalGroup(
                pagination: {
                    page: ${payload.pagination.page},
                    limit: ${payload.pagination.limit}
                }
              ) {
                verticalName,
                countOfOffers
                countOfDomains
                last7DaysAvg
                last30DaysAvg
                budget
                countOfAdv
                ou7
                ou30
                status
              }
            }
        `,
      }
    )
    return res.data.data.verticalGroup
  } catch (e) {
    console.log(e)
  }
}

const domainGroup = async (payload) => {
  try {
    let preparedFilters = ''

    if (payload.filters) {
      for (const filter in payload.filters) {
        preparedFilters += (!!payload.filters[filter]) ?
            `${filter}: "${payload.filters[filter]}"` : ''
      }
    }

    const res = await api.post(
      '', {
        query: `
            {
              domainGroup(
                sorting: {
                    orderBy: "${ !payload.sorting ? '' : payload.sorting.orderBy }",
                    orderDirectionAsc: ${ !payload.sorting ? true : payload.sorting.orderDirectionAsc}
                },
                filters: {
                  ${preparedFilters}
                }
              ) {
                id
                verticalName,
                countOfOffers
                domainName
                last7DaysAvg
                last30DaysAvg                
                budget
                advertiserId
                advertiserName
                advertiserEmail
                advertiserStatus
                advertiserMargin
                advertiserManagerName
                advertiserManagerId
                advertiserName
                ou7
                ou30
                status
              }
            }
        `,
      }
    )

    return res.data.data.domainGroup
  } catch (e) {
    console.log(e)
  }
}

const domainVerticalItems = async () => {

  try {
    const res = await api.post(
      '', {
        query: `
            {
              domainVerticalItems {
                domainVerticalId,
                offerId
                offerName
                offerStatus
                status
                url
                domainName
                verticalName
                advertiserId
                advertiserName
              }
            }
        `,
      }
    )
    return res.data.data.domainVerticalItems
  } catch (e) {
    console.log(e)
  }

}

const updateDomainsBudget = async (data) => {
  const domains =  JSON.stringify(data).replace(/"/g, '')

  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            updateDomainsBudget(
              domains:${domains}
            ){
              error
              count
              success
            }
          },
        `,
      }
    )

    return res.data.data.updateDomainsBudget
  } catch (e) {
    console.log(e)
  }
}

const updateOfferStatus = async (data) => {
  const {offersIds, status} = data
  const offers = JSON.stringify(offersIds).replace(/"/g, '')
  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            updateOffersStatus(
              offerIds:${offers}
              status:"${status}"
            ){
              error
              count
              success
            }
          },
        `,
      }
    )

    return res.data.data.updateOffersStatus
  } catch (e) {
    console.log(e)
  }
}

const domainBudgetImport = async (budgets) => {
  try {
    const formattedBudgets = budgets.map(budget => ({
      domain: budget.domain,
      budget: budget.budget,
      countriesToBlock: budget.countriesToBlock,
      countriesToUnBlock: budget.countriesToUnBlock
    }));

    const res = await api.post(
        '', {
          query: `
          mutation {
            domainBudgetImport(budgets: [
              ${formattedBudgets.map(budget => `
                {
                  domain: "${budget.domain}",
                  budget: ${budget.budget},
                  countriesToBlock: "${budget.countriesToBlock}",
                  countriesToUnBlock: "${budget.countriesToUnBlock}"
                }
              `).join(',')}
            ]) {
              success
              message
            }
          }
        `,
        }
    );

    return res.data.data.domainBudgetImport;
  } catch (e) {
    console.log(e);
  }
};



export default {
  verticalGroup,
  domainGroup,
  domainVerticalItems,
  updateDomainsBudget,
  updateOfferStatus,
  domainBudgetImport
}